// extracted by mini-css-extract-plugin
export default {"labelTextGroupList":"LabelTextGroupList_labelTextGroupList__cWDhL","labelTextGroup":"LabelTextGroupList_labelTextGroup__ROVq+"};